module.exports = __webpack_public_path__ + "static/img/dianchiyanshou.f2167f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dianchiyanshou.png
// module id = u5ap
// module chunks = 1